import { IPermissionsContext } from "../../ipermissions-context/ipermissions-context.interface";
import { IPermissions } from "../../ipermissions/ipermissions.interface";
import { hasUserGroup } from "../../ipermissions-context/ipermissions-context.functions";
import { UserGroup } from "../../../../../constants/types";
import { enablePermissions, setPermissions } from "../../ipermissions/ipermissions.functions";
import { IPermissionPolicyEvaluator } from "../../ipermissions/ipermission-policy.type";

export const adminGroupPolicy = (next?: IPermissionPolicyEvaluator) => (
  context: IPermissionsContext,
  permissions: IPermissions
) => {
  // console.log("checkAdminPolicy -->");

  if (hasUserGroup(context, UserGroup.ADMIN)) {
    // console.log("checkAdminPolicy --> TRUE");

    setPermissions(permissions, true, "canEdit", "manageReviewers");

    enablePermissions(
      permissions,
      "canArchive",
      "canDelete",
      "canView",
      "manageStatus",
      "updateReviewStatus",
      "manageCampBriefs",
      "manageExecBriefs",
      "manageWorkOrders",
      "manageProducts",
      "canCreateFlyer"
    );

    return;
  }

  if (next) {
    return next(context, permissions);
  }
};
